var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-download" }, [
    _c(
      "div",
      { class: { "st-show": _vm.isWechat }, attrs: { id: "dimmed-wechat" } },
      [
        _c("img", {
          attrs: { src: require("@/assets/download/img_open_browser.png") },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: { "st-show": _vm.isShowAndroidPopup },
        attrs: { id: "alert-andriod" },
      },
      [
        _c("div", {
          staticClass: "alert__dimmed",
          on: { click: _vm.closeAndroidPopup },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "alert__box" }, [
          _c(
            "button",
            {
              staticClass: "alert__close",
              on: { click: _vm.closeAndroidPopup },
            },
            [
              _c("img", {
                staticClass: "close-icon",
                attrs: { src: require("@/assets/download/img-close-icon.svg") },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "alert__title" }, [
            _vm._v("\n                都都GO\n            "),
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "alert__button",
              attrs: {
                href: "https://todoenglish-apk-download.enuma.cn/app-download/todoenglish-china-release.apk",
              },
            },
            [_vm._v("\n                下载\n            ")]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { attrs: { id: "download__pageview" } }, [
      _c("img", {
        staticClass: "img-bg",
        attrs: { src: require("@/assets/download/img-home-top.svg"), alt: "" },
      }),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "pageview__content" }, [
        _c("h1", { staticClass: "download__title" }, [
          _vm._v("\n                爱上英语 快乐空间\n            "),
        ]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "download__buttons" }, [
          _vm._m(4),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.openAndroidPopup.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/download/img-android-wh.svg"),
                  alt: "",
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm._m(5),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert__subtitle" }, [
      _vm._v(
        "\n                本安卓版本仅供中国大陆地区使用，\n                "
      ),
      _c("br"),
      _vm._v(
        "\n                在其他国家或地区可能无法正常使用。\n            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "alert__precautions" }, [
      _c("li", [
        _vm._v("如果您已经安装了“都都GO”，"),
        _c("br", { staticClass: "br-phone" }),
        _vm._v(" 您可以启动它来获取适用的更新。"),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("如果您发现更新之后存在两个“都都GO”，"),
        _c("br", { staticClass: "br-phone" }),
        _vm._v(" 请手动删除之前的版本。"),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "point-precaution" }, [
        _vm._v("需要Android系统版本10.0以上，"),
        _c("br", { staticClass: "br-phone" }),
        _vm._v("可使用存储空间1.5GB及以上。"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "download__header" }, [
      _c("img", {
        staticClass: "english-logo",
        attrs: { src: require("@/assets/download/img-coupon-logo-cn.png") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "download__biglogo" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/download/img-home-cn-logo.png"),
          alt: "Todo English Main Banner Logo",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "download__appstore",
        attrs: {
          href: "https://apps.apple.com/cn/app/id1500379448",
          target: "_blank",
        },
      },
      [
        _c("img", {
          attrs: {
            src: require("@/assets/download/img-appstore-wh.png"),
            alt: "",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "download__moredetail",
        attrs: {
          href: "http://mp.weixin.qq.com/s?__biz=MzA5MjkxMzY1NA==&mid=2247485550&idx=2&sn=6b4ee275eaa2848592e46c75382c3adc&chksm=9064a2f7a7132be1c53e747aae2d47a27580c6710cbf8a783695965ec49fb6a41d4d66b6ee97&scene=18#wechat_redirect",
          target: "_blank",
        },
      },
      [
        _vm._v("\n                查看都都GO详细介绍\n                "),
        _c("img", {
          staticClass: "img_homepage_arrow",
          attrs: { src: require("@/assets/download/img-homepage-arrow.svg") },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }